import { lazy, Suspense } from 'react';

import AddCardWalletModal from '#client/components/AddCardWalletModal';
import AdditionalInfoModal from '#client/components/AdditionalInfoModal';
import CardModal from '#client/components/CardModal';
import CreateNewCardModal from '#client/components/CreateNewCardModal';
import DownloadAppModal from '#client/components/DownloadAppModal';
import FreezeCardModal from '#client/components/FreezeCardModal';
import DepositMoneyModal from '#client/components/MoveMoney/DepositMoneyModal';
import InstantDepositModal from '#client/components/MoveMoney/InstantDepositModal';
import MoveMoneyChoiceViewModal from '#client/components/MoveMoney/MoveMoneyChoiceViewModal';
import SendMoneyModal from '#client/components/MoveMoney/SendMoneyModal';
import UnfreezeCardModal from '#client/components/UnfreezeCardModal';
import { MODAL_NAMES } from '#client/constants/modals';
import useModalContext, { useModalDataContext } from '#client/hooks/useModalContext';

const CheckDepositModal = lazy(() => import('#client/components/CheckDeposit'));
const ResubmitModal = lazy(() => import('#client/components/ResubmitModal'));
const testWithSuspenst = (props) => (
  <Suspense>
    <ResubmitModal {...props} />
  </Suspense>
);
const checkDeposit = (props) => (
  <Suspense>
    <CheckDepositModal {...props} />
  </Suspense>
);
const mapNameToComponent = {
  [MODAL_NAMES.CARD_MODAL]: CardModal,
  [MODAL_NAMES.MOVE_MONEY_CHOICE_VIEW_MODAL]: MoveMoneyChoiceViewModal,
  [MODAL_NAMES.ADD_CARD_WALLET_MODAL]: AddCardWalletModal,
  [MODAL_NAMES.DEPOSIT_MONEY_MODAL]: DepositMoneyModal,
  [MODAL_NAMES.SEND_MONEY_MODAL]: SendMoneyModal,
  [MODAL_NAMES.CHECK_DEPOSIT_RESUBMIT_MODAL]: testWithSuspenst,
  [MODAL_NAMES.CHECK_DEPOSIT_MODAL]: checkDeposit,
  [MODAL_NAMES.FREEZE_CARD_MODAL]: FreezeCardModal,
  [MODAL_NAMES.UNFREEZE_CARD_MODAL]: UnfreezeCardModal,
  [MODAL_NAMES.CREATE_NEW_CARD_MODAL]: CreateNewCardModal,
  [MODAL_NAMES.INSTANT_DEPOSIT_MODAL]: InstantDepositModal,
  [MODAL_NAMES.DOWNLOAD_APP_MODAL]: DownloadAppModal,
  [MODAL_NAMES.ADDITIONAL_INFO_MODAL]: AdditionalInfoModal
};

export default function OpenModals() {
  const modals = useModalDataContext();
  const { closeModal } = useModalContext();

  return (
    <>
      {modals.map(({ name, props, component }) => {
        const ModalComponent = component || mapNameToComponent[name];
        return (
          <ModalComponent
            handleClose={() => closeModal(name)}
            key={name}
            {...props}
          />
        );
      })}
    </>
  );
}
